<template>
  <div id="app">
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
   </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
  <!-- <router-view></router-view> -->
  </div>
</template>

<script>
/* IOS禁止微信调整字体大小 */
(function () {
  if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
    handleFontSize()
  } else {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize)
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
    }
  }
  function handleFontSize () {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', {'fontSize': 0})
    })
  }
})()
export default {
  name: 'App',
  created () {
    window.localStorage.setItem('sigUrl', window.location.href)
  }
}
</script>

<style lang="scss">
#app{height: 100%;
  .attentionPop{
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
}
body {
  /* IOS禁止微信调整字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue